export const raf = window.requestAnimationFrame || function(cb) { return setTimeout(cb, 1000 / 60); };
export const rafCancel = window.cancelAnimationFrame || function(timeout) { clearTimeout(timeout); };
